import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface IParametrosVariablesRequest {
  que: number;
  tope: string;
  cmd: string;
  parametro: string;
  promocion: string;
  valor: string;
  descripcion: string;
}

export interface IParametroVariable {
  parametro: string;
  producto: string;
  valor: string;
  descripcion: string;
}

export interface IParametrosVariablesResponse {
  success: boolean;
  data: IParametroVariable[];
}

export interface IOpcionesRequest {
  sTabla: string;
  sCampo: string;
  iIdioma: number;
}

export interface IOpcion {
  sOpcion: string;
  sValor: string;
}

export interface IOpcionesResponse {
  success: boolean;
  data: IOpcion[];
}

export interface IPromocion {
  producto: string;
  descripcion: string;
  tipoCredito: string | null;
  frecuenciaPago: string | null;
  pagoMinimo: string | null;
  tipoTasa: string | null;
  plazoMinimo: number;
  plazoMaximo: number;
  moneda: string | null;
  fechaInicio: string;
  fechaFin: string;
  empresa: string | null;
  sucursal: string | null;
  rutaCriticaAutomatica: number;
  tipoGarantia: string;
  tasaMinima: number;
  tasaMaxima: number;
  tablaScoring: number;
  orden: number;
  uso: string;
  precio: string;
  user: string | null;
}

export interface IPromocionesResponse {
  success: boolean;
  data: IPromocion[];
}

export interface IParametrosVariablesBaseResponse {
  success: boolean;
  data: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ParametrosvariablesService {
  constructor(private http: HttpClient) {}

  GetParametrosVariables(): Observable<IParametrosVariablesResponse> {
    const request: IParametrosVariablesRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      parametro: "",
      promocion: "",
      valor: "",
      descripcion: ""
    };
    return this.http.post<IParametrosVariablesResponse>(
      `${environment.apiNewBackBaseUrl}ParametrosVariables/ParametrosVariablesList`, 
      request
    );
  }

  GetOpciones(): Observable<IOpcionesResponse> {
    const request: IOpcionesRequest = {
      sTabla: "parametros",
      sCampo: "parametro",
      iIdioma: 0
    };
    return this.http.post<IOpcionesResponse>(
      `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetOpcionesVariables`, 
      request
    );
  }

  GetPromociones(): Observable<IPromocionesResponse> {
    const request = {
      limit: "99"
    };
    return this.http.post<IPromocionesResponse>(
      `${environment.apiNewBackBaseUrl}Gastos/GetGastos`, 
      request
    );
  }

  ParametrosVariablesAdd(request: IParametrosVariablesRequest): Observable<IParametrosVariablesBaseResponse> {
    return this.http.post<IParametrosVariablesBaseResponse>(
      `${environment.apiNewBackBaseUrl}ParametrosVariables/ParametrosVariablesAdd`, 
      request
    );
  }

  ParametrosVariablesUpd(request: IParametrosVariablesRequest): Observable<IParametrosVariablesBaseResponse> {
    return this.http.post<IParametrosVariablesBaseResponse>(
      `${environment.apiNewBackBaseUrl}ParametrosVariables/ParametrosVariablesUpd`, 
      request
    );
  }

  ParametrosVariablesDelete(request: IParametrosVariablesRequest): Observable<IParametrosVariablesBaseResponse> {
    return this.http.post<IParametrosVariablesBaseResponse>(
      `${environment.apiNewBackBaseUrl}ParametrosVariables/ParametrosVariablesDelete`, 
      request
    );
  }

  Getcmspr_campodetabla(tabla : string, campo : string): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + "api/ParametrosVariables/Getcmspr_campodetabla/" + tabla + "/" +campo );
  }

  Getcmspr_opciones(tabla : string, campo : string): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + "api/ParametrosVariables/cmspr_opciones/" + tabla + "/" +campo );
  }
}
